export const ACTIVE_WORKSPACE_SLUG_KEY = "activeWorkspaceSlug" as const;
export const ACTIVE_PROJECT_SLUG_KEY = "activeProjectSlug" as const;

/** The app language ("en" | "fr" | "de"), mirrored from the profile by the header. */
export const LOCALE_KEY = "locale" as const;

/**
 * CR-82: prefix of the per-document comments panel width, in pixels. The
 * document id is appended, so each document remembers its own width in this
 * browser (never synced, never sent to the server).
 */
export const DOCUMENT_COMMENT_SIDEBAR_WIDTH_PREFIX = "documentCommentSidebarWidth:" as const;

export const RECENT_WORKSPACE_SLUGS_KEY = "recentWorkspaceSlugs" as const;
export const RECENT_PROJECT_PATHS_KEY = "recentProjectPaths" as const;

/**
 * CR-140: prefix of the remembered CR board view (filters + sort). Unlike the
 * keys above this one lives in **sessionStorage** — per browser tab, kept on a
 * reload, gone when the tab closes. `<userId>:<projectId>` is appended.
 */
export const CR_BOARD_VIEW_KEY_PREFIX = "crBoardView:" as const;

/**
 * CR-125: the project left menu width, in whole pixels. Like the CR board view
 * above this lives in **sessionStorage** — per browser tab, kept on a reload,
 * back to the default in a new tab/session. One value for every project: the
 * left menu is a single surface. Never synced, never sent to the server.
 */
export const LEFT_MENU_SIDEBAR_WIDTH_KEY = "leftMenuSidebarWidth" as const;

/**
 * CR-202 S4: prefix of the chosen voice dictation language ("en" | "fr" | "de"
 * | "browser"). The user id is appended, so each user keeps their own choice in
 * this browser (never synced, never sent to the server). Stored as a raw
 * string, not JSON.
 */
export const VOICE_DICTATION_LANGUAGE_KEY_PREFIX = "voiceDictationLanguage:" as const;
